// Homepage banners
import banner_one from "../../assets/Carousel Banners/Aprl.jpg";
import banner_two from "../../assets/Carousel Banners/Conference_1.jpg";
import banner_three from "../../assets/Carousel Banners/Conference_2.jpg";
import banner_four from "../../assets/Carousel Banners/Conference_3.jpg";

// Banner images
export const banner_images = {
  banner_one,
  banner_two,
  banner_three,
  banner_four,
};
